export default __webpack_public_path__ + "whs-logo.308edaad.png";